import { render } from "./ArrowUpRightIcon.vue?vue&type=template&id=79be9e6c&scoped=true"
import script from "./ArrowUpRightIcon.vue?vue&type=script&lang=js"
export * from "./ArrowUpRightIcon.vue?vue&type=script&lang=js"

import "./ArrowUpRightIcon.vue?vue&type=style&index=0&id=79be9e6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79be9e6c"]])

export default __exports__